const ZeroHundred = () => {
	const eliminatedItems = [
		'Air Pollution',
		'Noise Pollution',
		'Range Anxiety',
		'Petrol Dependence',
		'Carbon Emission',
	];

	// Data for the 100% (Benefits/Achieved) card
	const achievedItems = [
		'Gearless Automatic Drive',
		'Dual Fuel Technology',
		'Portable Batteries',
		'Supports 8 SDG Goals',
		'Next-Gen Connectivity', // Added one more for balance
	];

	return (
		// <div className=" bg-gray-50 p-4 lg:p-12 font-sans flex flex-col items-center">

		<div className="flex flex-col lg:flex-row justify-between items-stretch w-full gap-8">
			{/* LEFT - 0% Section (Eliminated) */}
			{/* w-full on mobile, lg:w-1/2 on large. Items-stretch ensures equal height in row layout. */}
			<div className="flex flex-col lg:flex-row items-center w-full bg-gradient-to-br from-orange-50 to-orange-100 p-6 lg:p-10 rounded-3xl shadow-orange-200 shadow-lg lg:shadow-xl transition-all duration-500 lg:hover:shadow-2xl">
				{/* Large Rotated Number */}
				<div className="flex-1 flex items-center justify-center mb-4 lg:mb-0 lg:-rotate-90">

					<p className="text-8xl font-extrabold text-orange-800/80 drop-shadow-lg ">
						0%
					</p>

					


				</div>

				{/* List of Items */}
				<div className="flex flex-1 items-center">
					<div className="space-y-4 text-left font-semibold text-gray-800 text-lg lg:text-xl">
						<h2 className="ttext-lg flex-1 font-bold uppercase text-orange-700 border-b-2 border-orange-700 pb-1">
							Eliminated
						</h2>
						{eliminatedItems.map((item, idx) => (
							<p
								key={idx}
								className="flex items-center gap-3 transition-transform duration-300 transform hover:translate-x-1 cursor-default"
							>
								{/* Custom Checkmark/Bullet */}
								<svg
									className="w-5 h-5 text-orange-500 flex-shrink-0"
									fill="currentColor"
									viewBox="0 0 20 20"
								>
									<path
										fillRule="evenodd"
										d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
										clipRule="evenodd"
									/>
								</svg>
								{item}
							</p>
						))}
					</div>
				</div>
			</div>
			<div className="flex flex-col lg:flex-row items-center w-full bg-gradient-to-br  from-blue-50 to-blue-100 p-6 lg:p-10 rounded-3xl shadow-lg lg:shadow-xl shadow-blue-200 transition-all duration-500 lg:hover:shadow-2xl">
				{/* Large Rotated Number */}
				<div className="flex-1 flex items-center justify-center mb-4 lg:mb-0 lg:-rotate-90">

					<p className="text-8xl font-extrabold text-blue-800/80 drop-shadow-lg ">
						100%
					</p>

					

				</div>

				{/* List of Items */}
				<div className="flex flex-1 items-center justify-center">
					<div className="space-y-4 text-left font-semibold text-gray-800 text-lg lg:text-xl">
						<h2 className="ttext-lg flex-1 font-bold uppercase text-blue-700  border-b-2 border-blue-700 pb-1">
							Achieved
						</h2>
						{achievedItems.map((item, idx) => (
							<p
								key={idx}
								className="flex items-center gap-3 transition-transform duration-300 transform hover:translate-x-1 cursor-default"
							>
								{/* Custom Checkmark/Bullet */}
								<svg
									className="w-5 h-5 text-blue-500 flex-shrink-0"
									fill="currentColor"
									viewBox="0 0 20 20"
								>
									<path
										fillRule="evenodd"
										d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
										clipRule="evenodd"
									/>
								</svg>
								{item}
							</p>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};
export default ZeroHundred;
